import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace WarehouseItemValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            code: v.optional(baseVals.string()),
            quantity: v.number(),
            itemTypeId: baseVals.string(),
            locationId: baseVals.string(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            code: v.exactOptional(baseVals.string()),
        }),
    );

    export const RecordHistory = defineValidation(BaseRecordSchema);
}
